import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IncentiveService } from '@services/incentive.service';
import { IncentiveDetail } from '@app/models/incentive/incentive-detail';
import { BaseComponent } from '@core/component/base/base.component';
import { I18nService } from '@core/services/i18n/i18n.service';
import { AuthService } from '@services/auth.service';
import { aesEncrypt } from '@core/utils/crypto.utils';
import { Router } from '@angular/router';
import { ROUTER_UTILS } from '@core/utils/router.utils';

import { CommonModule } from '@angular/common';
import { IncentiveViewComponent } from '@app/components/incentive-view/incentive-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
@Component({
  standalone: true,
  selector: 'app-incentive-modal',

  imports: [CommonModule, TranslateModule, NzIconModule, NzModalModule, NzPopconfirmModule, IncentiveViewComponent],
  templateUrl: './incentive-modal.component.html',
  styleUrls: ['./incentive-modal.component.less'],
})
export class IncentiveModalComponent extends BaseComponent implements OnInit {
  @Output() closeEvt = new EventEmitter();

  isVisible = false;
  isOpen = false;
  incentiveDetail!: IncentiveDetail;

  qrUrl = '';

  constructor(
    i18nService: I18nService,
    authService: AuthService,
    private incentiveService: IncentiveService,
    private router: Router,
  ) {
    super(authService, i18nService);
  }

  ngOnInit(): void {
    this.getRandomIncentive();
  }

  getRandomIncentive() {
    this.incentiveService.getRandomIncentive().subscribe(res => {
      this.incentiveDetail = res;
      this.generateIncentiveShareUrl();
    });
  }

  path = ROUTER_UTILS.business;
  generateIncentiveShareUrl() {
    if (this.incentiveDetail) {
      const title = this.incentiveDetail.incentiveInfo?.TITLE?.value || '';
      const encryptedParams = aesEncrypt(
        `${this.incentiveDetail.period}&&${this.incentiveDetail.viewId}&&${this.incentiveDetail.rule.ruleKey}&&${title}`,
      );
      const url = this.router.serializeUrl(
        this.router.createUrlTree([this.path.incentive.root, this.path.incentive.shareMyecom], {
          queryParams: { q: encryptedParams },
        }),
      );
      const qrShareUrl = location.origin + '/kwt/assets/share/share.html?q=' + encodeURIComponent(encryptedParams);
      this.qrUrl = qrShareUrl;
    }
  }

  handleClose(): void {
    this.isOpen = false;
    setTimeout(() => {
      this.isVisible = false;
      this.closeEvt.emit(false);
    }, 500);
  }

  handleZoonOut(): void {
    this.isOpen = false;
    setTimeout(() => {
      this.isVisible = false;
      this.closeEvt.emit(true);
    }, 500);
  }

  handleShow(): void {
    if (this.incentiveDetail) {
      this.isVisible = true;
      this.isOpen = true;
    }
  }
}
